import { NgModule } from '@angular/core';
import { MsSelectComponent } from './ms-select.component';
import { SharedLibsModule } from 'app/shared/shared-libs.module';

@NgModule({
	declarations: [MsSelectComponent],
	imports: [SharedLibsModule],
	exports: [MsSelectComponent],
	providers: [],
})
export class MsSelectModule {}
